import { TFunction } from "next-i18next";

import { ContactTypes, SocialTypes } from "constants/enum";
import contacts from "configs/contacts";
import { PageContentProps } from "content/content.types";

export default (t: TFunction, { locale }: PageContentProps) => [
    {
        link: `tel:${contacts.phone[locale].link}`,
        icon: ContactTypes.PHONE,
        title: contacts.phone[locale].link,
    },
    {
        link: contacts.whatsapp[locale].link,
        icon: SocialTypes.WA,
        title: "WhatsApp",
    },
    {
        link: contacts.email[locale].link,
        icon: ContactTypes.EMAIL,
        title: t("global:email"),
    },
];
